// Copyright (c) 2026 by Audere

import { LabelTask, PersonaOption } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./commonV3";

export const celosiaLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "northernNdebeleTranslationLabeling",
    name: "Translation labeling Northern Ndebele",
    description: "Label the translation quality of Northern Ndebele language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
  {
    id: "shonaTranslationLabeling",
    name: "Translation labeling Shona",
    description: "Label the translation quality of Shona language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const celosiaLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const celosiaQuestions = [...commonQuestions, ...translationQuestions];

const celosiaPersonas: PersonaOption[] = [
  {
    id: "TRUSTED_FRIEND",
    name: "Trusted Friend",
    description:
      "Young Zimbabwean woman, warm and empathetic, casual with Gen Z slang, peer-level " +
      "connection, balances seriousness with humor.",
  },
  {
    id: "TRUSTED_FRIEND_MALE",
    name: "Trusted Friend (Male)",
    description:
      "A young Zimbabwean man in his early-to-mid 20s. Relaxed but real — doesn't sugarcoat " +
      "things but doesn't make them heavier than they need to be — using everyday language that " +
      "cuts through medical jargon.",
  },
  {
    id: "OLDER_SISTER",
    name: "Older Sister",
    description:
      "Caring, confident older sister in her 20s from Zimbabwe, slightly playful sisterly " +
      "tone, empathetic, offers practical and relatable advice from her own recent experiences " +
      "as a teenager and young adult.",
  },
  {
    id: "HEALTHCARE_PROFESSIONAL",
    name: "Healthcare Professional",
    description:
      "Compassionate healthcare professional in Zimbabwe, warm and non-judgmental, creates a " +
      "safe space specifically for young girls to ask questions without fear of judgment.",
  },
  {
    id: "AUNT",
    name: "Tete",
    description:
      "Wise tete (auntie) in her mid-30s from Zimbabwe, blends traditional wisdom with modern " +
      "understanding, \"the trusted adult\" who creates safe spaces for honest conversations. " +
      "Practical, optimistic without ignoring reality, approachable enough for difficult " +
      "topics, connected to youth culture despite the age gap.",
  },
  {
    id: "HCW_ADVISOR",
    name: "Healthcare Worker Advisor",
    description:
      "An AI coach for healthcare workers and peer educators in Zimbabwe. Warm, respectful, and " +
      "professional — supplies clinical knowledge, phrasing, and counseling approaches quickly " +
      "and precisely, without overstepping into clinical decisions.",
  },
];

export const celosiaLabelingSchemaV3 = {
  labelingTypes: celosiaLabelingTypes,
  labelingTasks: celosiaLabelingTasks,
  labelingQuestions: celosiaQuestions,
  labelingSchemaVersion: "celosiaLabelingSchemaV3",
  personas: celosiaPersonas,
};
